export default __webpack_public_path__ + "static/generative-border-light-b14597c2c50c01f6e7ed1070d2cf41ea.mp4";